var map = {
	"./Clocks/end.jpg": "OF0E",
	"./Clocks/start.jpg": "54Vr",
	"./Glasses/end.jpg": "YBo+",
	"./Glasses/start.jpg": "utcr",
	"./GulpOfWater/end.jpg": "p37+",
	"./GulpOfWater/start.jpg": "zgsq",
	"./Magazine/end.jpg": "0zyp",
	"./Magazine/start.jpg": "REYE",
	"./MagazineSpyglass/end.jpg": "cGg3",
	"./MagazineSpyglass/start.jpg": "jC3N",
	"./Melon/end.jpg": "QDT4",
	"./Melon/start.jpg": "1QX6",
	"./Nails/end.jpg": "L5YS",
	"./Nails/start.jpg": "Iz2a",
	"./RoundMove/end.jpg": "RAS3",
	"./RoundMove/start.jpg": "O/2X",
	"./Smena7/end.jpg": "4RsK",
	"./Smena7/start.jpg": "8Ovv",
	"./Sweeping/end.jpg": "i/KH",
	"./Sweeping/start.jpg": "/fsB",
	"./Waving/end.jpg": "Jfop",
	"./Waving/start.jpg": "gAwb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+l0z";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg \.jpg$
// module id = +l0z
// module chunks = 1